import axios from 'common/utils/axios';

const activitiesApi = axios('activities');

export const useActivitiesCriticalities = (params: any) => {
  return activitiesApi.get('criticality', { params });
};
